import React, {useEffect, useState} from "react";
import CommonTitle from "../../components/common-title";
import {queryMaterialInfo} from "../../service";
import {companyMaterial,} from '../types'
import usePagination from "../../routers/usePagination";
import logo from '../../images/logo-gold.png'

function CompanyMaterial() {

    const [lists,setLists] = useState<Array<companyMaterial>>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination();

    useEffect(() =>{
        queryMaterialInfo({
            key: '1,2'
        }).then(res => {
            if(res.msg === 'success'){
                const lists = res.page.list
                if((lists as Array<companyMaterial>).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            }
        })
    },[pageNum])

    return <div className="companyCertificate">
        <img src={logo} alt="" className='_logo'/>
        <CommonTitle title={"资料列表"}/>
            {
                lists.map((item,index) => {
                    return <div  style={{display:'flex',borderBottom:'1px solid #eee'}} key={index}>
                        <div  style={{fontSize:'16px',left:'10px',width:'80%',lineHeight: '2.2',fontWeight:'bold',color:'#00306e'}}>
                            { item.materialName }
                        </div>
                        <a  style={{
                            color:'#fff',
                            fontSize:'.26rem',
                            width: '1.2rem',
                            textAlign: 'center',
                            background:'#00306E',
                            lineHeight: '.8rem' ,
                            borderTopRightRadius: '.1rem',
                            borderBottomRightRadius: '.1rem',
                        }} href={item.materialUrl}>下载</a>
                    </div>
                })
            }

    </div>
}

export default CompanyMaterial
